import { fetchApi } from "../../config/fetchConfig";
import I18n from "../../I18n";
import { buildRequestBodyAsync } from "../../utils";
import { pushDialog } from "./dialogActions";

import dompurify from "dompurify";

const downloadStart = () => ({
    type: "DOWNLOAD_START",
});
const downloadEnd = () => ({
    type: "DOWNLOAD_END",
});

export const downloadAction = (argQueries, locale) => async (dispatch, getState) => {
    const queries = (argQueries || []).map((q) => {
        return {
            ...q,
            args: {
                ...(q.args || {}),
                page: 0,
                pageSize: 5000,
            },
        };
    });

    // Use async builder to inject DB xlsx labels when xlsxTranslation is present
    let queriesBodies = await buildRequestBodyAsync(
        queries,
        locale,
        true,
        (url, body, opts) => fetchApi(url, body, opts, { dispatch, user: getState()?.user }),
    );
    queriesBodies.query = (queriesBodies.query || {}).replace("__typename,id,", "");

    dispatch(downloadStart());

    fetchApi(
        "/api/download_xls",
        queriesBodies,
        {
            headers: { "Content-Type": "application/json" },
        },
        { dispatch, user: getState()?.user },
    )
        .then((t) => {
            if (t.status !== 200) {
                dispatch(downloadEnd());
                dispatch(
                    pushDialog("AlertDialog", I18n.translate`Xlsx Export Error`, {
                        title: I18n.translate`Something went wrong when generating the requested file`,
                    }),
                );
            } else {
                dispatch(downloadEnd());
                return t.blob().then((b) => {
                    if (b && b.size > 20) {
                        const a = document.createElement("a");
                        const filename = t.headers.get("Filename");

                        a.href = dompurify.sanitize(URL.createObjectURL(b));
                        a.setAttribute("download", `${filename}.xlsx`);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        console.error("empty file");
                    }
                });
            }
        })
        .catch(() => {
            dispatch(downloadEnd());
            dispatch(
                pushDialog("AlertDialog", I18n.translate`Xlsx ExportError`, {
                    title: I18n.translate`Something went wrong when generating the requested file`,
                }),
            );
        });
};

export const getDownloadTemplateData = (projectId, country, entity) => (dispatch, getState) => {
    const queriesBody = {
        query: `query($p:String!,$c:String!, $e:String!){get_download_template_data(projectId:$p,country:$c, entity:$e){countries{value,name,taxRegistrationNumber}, entities{value,name}, columns}}`,
        variables: {
            p: `${projectId}`,
            c: `${country}`,
            e: `${entity}`,
        },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            const data = res.data["get_download_template_data"] || {};
            return data;
        })
        .catch((e) => {
            dispatch(
                pushDialog("AlertDialog", I18n.translate`Request Error`, {
                    title: I18n.translate`Somethings went wrong getting download template data`,
                }),
            );
        });
};
